import script from "./GradeNumberChart.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeNumberChart.vue?vue&type=script&setup=true&lang=js"

import "./GradeNumberChart.vue?vue&type=style&index=0&id=bb1db2cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1db2cc"]])

export default __exports__